const styles = {
  root: { mt: 1 },
  emptyCheck: {
    width: '16px',
    height: '16px',
    border: '1px solid',
    borderRadius: '4px',
    borderColor: 'divider',
  },
  item: {
    backgroundColor: 'background.default',
    border: 1,
    borderColor: 'background.grey400',
    borderRadius: 1,
  },
  field: {
    width: '100%',
    '&.MuiFormControlLabel-root': {
      ml: 0,
      mr: 0,
      padding: 1.5,
    },
  },

  checkContainer: {
    mr: 1,
    maxHeight: 16,
    '& svg >  *': {
      fill: '#000',
    },
  },
  text: {
    '&.MuiTypography-root': {
      fontWeight: 400,
    },
  },
}

export default styles
